// Utility to get global page size from Redux store
import { useSelector } from 'react-redux';
import { PAGE_LIMIT } from '../constants';

/**
 * Get the global page size from Redux state
 * This can be used by components that need to know the page size before mounting tables
 * 
 * @param {Object} state - Redux state
 * @returns {number} - The global page size or default PAGE_LIMIT
 */
export const getGlobalPageSize = (state) => {
  return state?.tableReducer?.globalPageSize || PAGE_LIMIT;
};

/**
 * Hook to get global page size from Redux store
 * Use this in components that need the page size for data fetching
 */
export const useGlobalPageSize = () => {
  return useSelector(getGlobalPageSize);
};